import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButtonToggleChange} from '@angular/material/button-toggle';

@Component({
    selector: 'app-ssdf-call-filters-dashboard',
    templateUrl: './ssdf-call-filters-dashboard.component.html',
    styleUrls: ['./ssdf-call-filters-dashboard.component.scss']
})
export class SsdfCallFiltersDashboardComponent implements OnInit {
    @Input() selectedDashboardView: string;
    @Input() selectedDateFilter: string;
    @Input() filterDates: any;
    @Input()  showDashboardViewMenu : boolean;

    @Output() onChangeDateFilterState = new EventEmitter<any>();
    @Output() onChangeDashboardView = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    changeDateFilterState($event: MatButtonToggleChange) {
        this.onChangeDateFilterState.emit($event);
    }

    changeDashboardView(view: string) {
        this.onChangeDashboardView.emit(view);
    }
}
